function toStartOfUTCDay(d) {
  const date = new Date(d);

  date.setUTCMilliseconds(0);
  date.setUTCSeconds(0);
  date.setUTCMinutes(0);
  date.setUTCHours(0);

  return date;
}

export default toStartOfUTCDay;
